import { apiClient } from '@/shared/api';

import type {
  ChannelScope,
  ChannelScopeUpsert,
  LocationGroup,
  LocationGroupUpsert,
  StoreOverride,
  StoreOverrideUpsert,
  StoreScope,
  StoreScopeUpsert,
} from '../model/types';

const BASE = '/api/v1/inventory/availability';

export const listLocationGroups = async (): Promise<LocationGroup[]> =>
  (await apiClient.get<LocationGroup[]>(`${BASE}/location-groups`)).data;

export const upsertLocationGroup = async (body: LocationGroupUpsert): Promise<LocationGroup> =>
  (await apiClient.put<LocationGroup>(`${BASE}/location-groups`, body)).data;

export const deleteLocationGroup = async (groupId: string): Promise<void> => {
  await apiClient.delete(`${BASE}/location-groups/${groupId}`);
};

export const listChannelScopes = async (): Promise<ChannelScope[]> =>
  (await apiClient.get<ChannelScope[]>(`${BASE}/channel-scopes`)).data;

export const upsertChannelScope = async (
  channelCode: string,
  body: ChannelScopeUpsert,
): Promise<ChannelScope> =>
  (await apiClient.put<ChannelScope>(`${BASE}/channel-scopes/${encodeURIComponent(channelCode)}`, body)).data;

export const deleteChannelScope = async (channelCode: string): Promise<void> => {
  await apiClient.delete(`${BASE}/channel-scopes/${encodeURIComponent(channelCode)}`);
};

export const listStoreScopes = async (): Promise<StoreScope[]> =>
  (await apiClient.get<StoreScope[]>(`${BASE}/store-scopes`)).data;

export const upsertStoreScope = async (storeCode: string, body: StoreScopeUpsert): Promise<StoreScope> =>
  (await apiClient.put<StoreScope>(`${BASE}/store-scopes/${encodeURIComponent(storeCode)}`, body)).data;

export const deleteStoreScope = async (storeCode: string): Promise<void> => {
  await apiClient.delete(`${BASE}/store-scopes/${encodeURIComponent(storeCode)}`);
};

export const listStoreOverrides = async (storeCode: string): Promise<StoreOverride[]> =>
  (await apiClient.get<StoreOverride[]>(`${BASE}/store-scopes/${encodeURIComponent(storeCode)}/overrides`)).data;

export const upsertStoreOverride = async (
  storeCode: string,
  productId: string,
  body: StoreOverrideUpsert,
): Promise<StoreOverride> =>
  (
    await apiClient.put<StoreOverride>(
      `${BASE}/store-scopes/${encodeURIComponent(storeCode)}/overrides/${productId}`,
      body,
    )
  ).data;

export const deleteStoreOverride = async (storeCode: string, productId: string): Promise<void> => {
  await apiClient.delete(`${BASE}/store-scopes/${encodeURIComponent(storeCode)}/overrides/${productId}`);
};
